import { Button, IconButton } from '@themenu/design-system'
import React, { type FC, type PropsWithChildren } from 'react'
import { useIntl } from 'react-intl'
import { useIsMobile } from '../../hooks/useIsMobile'

type BackButtonLayoutProps = {
  onBack?: () => void
  showBackButton: boolean
  fullWidth?: boolean
}

export const BackButtonLayout: FC<PropsWithChildren<BackButtonLayoutProps>> = ({
  showBackButton,
  onBack,
  fullWidth = false,
  children,
}) => {
  const isMobile = useIsMobile()
  const { formatMessage } = useIntl()

  return (
    <>
      <header className="mt-8 xs:mt-24 flex w-full justify-between px-20">
        {showBackButton ? (
          <div>
            {isMobile ? (
              <div className="my-8 flex min-h-24 items-end justify-start">
                <IconButton
                  variant="alternativeText"
                  size={24}
                  name="chevron-left"
                  onClick={onBack}
                  aria-label={formatMessage({ id: 'sign_in.back_button' })}
                />
              </div>
            ) : (
              <Button variant="secondary" startIcon="chevron-left" size={40} onClick={onBack}>
                {formatMessage({ id: 'sign_in.back_button' })}
              </Button>
            )}
          </div>
        ) : (
          <div className="min-h-40" />
        )}
      </header>
      <main
        className={
          fullWidth
            ? 'mx-auto flex w-full max-w-[600px] flex-1 pb-16'
            : 'mx-auto xs:block flex w-full xs:w-[445px] flex-1 pb-16'
        }
      >
        {children}
      </main>
    </>
  )
}
